import axiosClient from '../util/request';

const forgotPasswordRepo = {
  requestResendPassword: (email: string) => axiosClient.post(`/v1/users/forgot-password/${email}`),
};

export default forgotPasswordRepo;
